/* @flow */

// polyfills - do not remove
import "core-js/stable";
import "regenerator-runtime/runtime";

import * as analyticsService from './services/analytics';
import * as traceService from './services/trace';
import { store } from './stores/store';
import Immutable from 'immutable';
import React from 'react';
import { render } from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import { history as browserHistory } from './history';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import '../scss/style.scss';

import App from './app';
import NotFound from './shared_components/not_found';
import HomeWrapper from './home_components/home_wrapper';

// disable Immutable.js length warning
Immutable.Iterable.noLengthWarning = true;

window.React = React;

if (process.env.NODE_ENV !== 'production') {
  window.TestUtils = require('react-dom/test-utils');
}

// prevent Safari from exiting full screen mode with escape
document.addEventListener('keypress', function(e: Event) {
  if (e instanceof KeyboardEvent && e.which === 27) e.preventDefault();
}, true);

analyticsService.start(store);

if (window.location.search.indexOf('trace=true') !== -1) {
  traceService.start(store);
}

// allow non-componets to interact with the routeing engine
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: state => state.get('routing')
});

function isCanonicalPath(path: string): boolean {
  return path.endsWith('/');
}

function routerUpdate() {
  if (!isCanonicalPath(this.state.location.pathname)) {
    this.router.replace({
      ...this.state.location,
      pathname: this.state.location.pathname + '/'
    });
  }
}

render(
  <Provider store={store}>
    <div>
      <Router history={browserHistory}>
        <App>
          <Switch>
            <Route path="(|/|/@|/place|/search|/view)" component={HomeWrapper} />
            <Route component={NotFound} />
          </Switch>
        </App>
      </Router>
    </div>
  </Provider>,
  document.getElementById('app')
);
